"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _pathfinding = _interopRequireDefault(require("./pathfinding.js"));

var _getFloorFromName = _interopRequireDefault(require("./getFloorFromName.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SceneWrapper = function SceneWrapper(_scene, sceneOptions, functions) {
  var _this = this;

  _classCallCheck(this, SceneWrapper);

  this.setOrthoCamera = function (scale) {
    var _this$scene$canvas$ge = _this.scene.canvas.getBoundingClientRect(),
        width = _this$scene$canvas$ge.width,
        height = _this$scene$canvas$ge.height;

    _this.scene.camera.orthoTop = scale * height;
    _this.scene.camera.orthoBottom = -scale * height;
    _this.scene.camera.orthoLeft = -scale * width;
    _this.scene.camera.orthoRight = scale * width;

    if (_this.disablePanning) {
      return;
    }

    var pointers = _this.scene.camera.inputs.attached.pointers;
    var _this$scene$options = _this.scene.options,
        _this$scene$options$u = _this$scene$options.upperZoomLimit,
        upperZoomLimit = _this$scene$options$u === void 0 ? Infinity : _this$scene$options$u,
        _this$scene$options$l = _this$scene$options.lowerZoomLimit,
        lowerZoomLimit = _this$scene$options$l === void 0 ? 0 : _this$scene$options$l;
    var zoomLevel = 1 - (scale - lowerZoomLimit) / (upperZoomLimit - lowerZoomLimit); // Range from 75 at zoom out, to 250 at zoom in

    pointers.panningSensibility = 175 * zoomLevel + 75;
  };

  this.updateZoomLimit = function (_ref) {
    var upperZoomLimit = _ref.upperZoomLimit,
        lowerZoomLimit = _ref.lowerZoomLimit;
    _this.scene.options.upperZoomLimit = upperZoomLimit;
    _this.scene.options.lowerZoomLimit = lowerZoomLimit;
  };

  this.resetCamera = function () {
    var _this$scene = _this.scene,
        camera = _this$scene.camera,
        _this$scene$options2 = _this$scene.options,
        options = _this$scene$options2 === void 0 ? {} : _this$scene$options2;

    _this.setOrthoCamera(options.orthoScale || 0.01);

    _this.orthoScale = options.orthoScale || 0.01;
    camera.setTarget(new BABYLON.Vector3(0, 0, 0));

    _this.rotateFloors(0);

    _this.setRotation(0);
  };

  this.updateControls = function (_ref2) {
    var disablePanning = _ref2.disablePanning,
        disableRotationX = _ref2.disableRotationX,
        disableRotationY = _ref2.disableRotationY;
    var pointers = _this.scene.camera.inputs.attached.pointers;

    if (!pointers) {
      return;
    }

    pointers.panningSensibility = disablePanning ? 0 : 75;
    pointers.angularSensibilityY = disableRotationX ? Infinity : 2500;

    if (disableRotationY) {
      _this.rotateFloors(0);

      _this.setRotation(0);
    }

    _this.disableRotationY = disableRotationY;
  };

  this.updateCameraBeta = function (beta) {
    _this.scene.camera.beta = beta;
  };

  this.rotateFloors = function (rotation) {
    _this.scene.floors.forEach(function (_ref3) {
      var name = _ref3.name;

      var m = _this.scene.getMeshByName(name);

      if (!m) {
        return;
      }

      m.rotation.y = rotation;
    });
  };

  this.getInitialNodePointArray = function () {
    var nodeSize = _this.nodeSize; // Create a shape like >| to show screen orientation

    var h = -0.08 * nodeSize;
    var w = 0.05 * nodeSize;
    return [[1, 1], [0.25, -0.75], [1, -0.75], [1, -1], [-1, -1], [-1, -0.75], [-0.25, -0.75], [-1, 1]].map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          x = _ref5[0],
          y = _ref5[1];

      return new BABYLON.Vector2(x * h, y * w);
    });
  };

  this.log = function () {
    if (_this.debug > 1) {
      var _console;

      (_console = console).log.apply(_console, arguments);
    }
  };

  this.timeStart = function (label) {
    if (_this.debug > 0) {
      console.log('Starting timer for', label);
      console.time(label);
    }
  };

  this.timeEnd = function (label) {
    if (_this.debug > 0) {
      console.timeEnd(label);
    }
  };

  this.cameraMove = function (move) {
    var factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    // Same handlers for rotation
    var _this$scene2 = _this.scene,
        camera = _this$scene2.camera,
        options = _this$scene2.options;
    var _options$upperZoomLim = options.upperZoomLimit,
        upperZoomLimit = _options$upperZoomLim === void 0 ? Infinity : _options$upperZoomLim,
        _options$lowerZoomLim = options.lowerZoomLimit,
        lowerZoomLimit = _options$lowerZoomLim === void 0 ? 0 : _options$lowerZoomLim;

    if (move === 'up') {
      camera.beta -= 0.01 * factor;
      return;
    }

    if (move === 'down') {
      camera.beta += 0.01 * factor;
      return;
    }

    if (move === 'left') {
      camera.alpha -= 0.01 * factor;
      return;
    }

    if (move === 'right') {
      camera.alpha += 0.01 * factor;
      return;
    }

    if (move.includes('pan')) {
      var _camera$getTarget = camera.getTarget(),
          targetX = _camera$getTarget.x,
          targetY = _camera$getTarget.y,
          targetZ = _camera$getTarget.z;

      var _camera$position = camera.position,
          camX = _camera$position.x,
          camZ = _camera$position.z;

      var _camera$position$subt = camera.position.subtract(camera.getTarget()),
          diffX = _camera$position$subt.x,
          diffZ = _camera$position$subt.z;

      var distance = Math.sqrt(Math.pow(targetX - camX, 2) + Math.pow(targetZ - camZ, 2));
      var ratioX = diffX / (distance * 10) * (factor * 2);
      var ratioZ = diffZ / (distance * 10) * (factor * 2);
      var alpha = camera.alpha,
          beta = camera.beta,
          radius = camera.radius;
      var newX;
      var newZ;

      if (move === 'panForward') {
        newX = targetX - ratioX;
        newZ = targetZ - ratioZ;
      }

      if (move === 'panBack') {
        newX = targetX + ratioX;
        newZ = targetZ + ratioZ;
      }

      if (move === 'panLeft') {
        newX = targetX + ratioZ;
        newZ = targetZ - ratioX;
      }

      if (move === 'panRight') {
        newX = targetX - ratioZ;
        newZ = targetZ + ratioX;
      }

      var _camera$panningOrigin = camera.panningOriginTarget,
          centerX = _camera$panningOrigin.x,
          centerZ = _camera$panningOrigin.z;
      var newDistance = Math.sqrt(Math.pow(newX - centerX, 2) + Math.pow(newZ - centerZ, 2));

      if (!camera.panningDistanceLimit || newDistance < camera.panningDistanceLimit) {
        camera.setTarget(new BABYLON.Vector3(newX, targetY, newZ));
        camera.alpha = alpha;
        camera.beta = beta;
        camera.radius = radius;
      }

      return;
    }

    if (camera.mode === BABYLON.Camera.ORTHOGRAPHIC_CAMERA) {
      // Orthographic handlers
      if (move === 'in') {
        _this.orthoScale *= 1 - factor / 10;
        _this.orthoScale = Math.min(Math.max(_this.orthoScale, lowerZoomLimit), upperZoomLimit);

        _this.setOrthoCamera(_this.orthoScale);

        return;
      }

      if (move === 'out') {
        _this.orthoScale *= 1 + factor / 10;
        _this.orthoScale = Math.min(Math.max(_this.orthoScale, lowerZoomLimit), upperZoomLimit);

        _this.setOrthoCamera(_this.orthoScale);

        return;
      }
    } else {
      // Perspective handlers
      if (move === 'in') {
        camera.radius -= 0.1 * factor;
        return;
      }

      if (move === 'out') {
        camera.radius += 0.1 * factor;
        return;
      }
    }
  };

  this.unsetRotation = function () {
    _this.log('Unset rotation');

    _this.cachedRotationValues = {};

    _this.scene.floors.forEach(function (_ref6) {
      var name = _ref6.name;

      var m = _this.scene.getMeshByName(name);

      _this.cachedRotationValues[name] = m.rotation.y;
      m.rotation.y = 0;
    });
  };

  this.resetRotation = function () {
    _this.log('Reset rotation');

    _this.scene.floors.forEach(function (_ref7) {
      var name = _ref7.name;

      var m = _this.scene.getMeshByName(name);

      m.rotation.y = _this.cachedRotationValues[name] || 0;
    });
  };

  this.toggleAccessibility = function () {
    _this.log('Toggled accessibility');

    _this.pathfinding.accessibilityOnly = !_this.pathfinding.accessibilityOnly;
  };

  this.getMaterial = function (name, color) {
    _this.log('Creating or reusing material', name, color);

    var foundMaterial = _this.scene.getMaterialByName(name);

    if (foundMaterial) {
      _this.log('Reusing material', foundMaterial.diffuseColor);

      return foundMaterial;
    }

    var newMaterial = new BABYLON.StandardMaterial(name, _this.scene);
    newMaterial.diffuseColor = new BABYLON.Color3.FromHexString(color);
    newMaterial.specularColor = new BABYLON.Color3(0, 0, 0);

    _this.log('New material', newMaterial.diffuseColor);

    return newMaterial;
  };

  this.addMeshToHighlights = function (color, permanent) {
    for (var _len = arguments.length, assetNames = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      assetNames[_key - 2] = arguments[_key];
    }

    if (assetNames.length) {
      assetNames.forEach(function (id) {
        var mesh = _this.scene.getMeshByName(id);

        if (mesh) {
          _this.enableHighlight(mesh, color, permanent);
        }
      });
    }
  };

  this.wireframeMesh = function (name) {
    var mesh = _this.scene.getMeshByName(name);

    if (!mesh.oldMaterial) {
      mesh.oldMaterial = mesh.material;
    }

    mesh.oldPickable = mesh.isPickable;
    _this.tempHighlights = _this.tempHighlights.filter(function (h) {
      return h !== mesh;
    });

    _this.tempHighlights.push(mesh);

    var wireMaterial = mesh.material.clone('wireMaterial');
    wireMaterial.wireframe = true;
    mesh.material = wireMaterial;
    mesh.isPickable = false;
  };

  this.enableHighlight = function (mesh, color, permanent) {
    // this.log('Enable highlight', {
    //   mesh, color, permanent
    // })
    _this.tempHighlights.forEach(function (tempMesh) {
      SceneWrapper.disableHighlight(tempMesh);
    });

    if (!mesh.oldMaterial) {
      mesh.oldMaterial = mesh.material;
    }

    _this.highlights = _this.highlights.filter(function (h) {
      return h !== mesh;
    });
    _this.tempHighlights = _this.tempHighlights.filter(function (h) {
      return h !== mesh;
    });

    if (permanent) {
      _this.highlights.push(mesh);
    } else {
      _this.tempHighlights.push(mesh);
    }

    var highLightMaterial = _this.getMaterial("highlight - ".concat(color), color);

    mesh.material = highLightMaterial;
  };

  this.createFloorDot = function (_ref8) {
    var position = _ref8.position,
        floor = _ref8.floor;
    var floorDot = BABYLON.MeshBuilder.CreateSphere('floorDot', {
      diameter: 0.16 * _this.nodeSize,
      diameterY: 0.01
    }, _this.scene);

    var dotMaterial = _this.getMaterial('floorDot', '#000000');

    floorDot.position = position;
    floorDot.floorName = floor;
    floorDot.material = dotMaterial;
    floorDot.isPickable = false;
    _this.scene.floorDot = floorDot;
  };

  this.moveFloorDot = function (_ref9) {
    var position = _ref9.position,
        floor = _ref9.floor;

    if (_this.scene.floorDot) {
      _this.scene.floorDot.position = position;
      _this.scene.floorDot.floorName = floor;
    }
  };

  this.createLinkMesh = function (assetName1, assetName2) {
    var scene = _this.scene;
    var mesh1 = scene.getMeshByName(assetName1);
    var mesh2 = scene.getMeshByName(assetName2);

    if (!mesh1 || !mesh2) {
      return {
        name: ''
      };
    }

    var parent = mesh1.parent || mesh2.parent;
    var linkName = "link-|".concat(assetName1, "|").concat(assetName2, "|");

    var isRoomLink = _this.reservedWords.some(function (w) {
      return linkName.toLocaleLowerCase().includes(w);
    });

    var lowestY = Math.min(mesh1.absolutePosition.y, mesh2.absolutePosition.y, parent.absolutePosition.y);
    var linkMesh = BABYLON.MeshBuilder.CreateTube(linkName, {
      path: [new BABYLON.Vector3(mesh1.absolutePosition.x, lowestY, mesh1.absolutePosition.z), new BABYLON.Vector3(mesh2.absolutePosition.x, lowestY, mesh2.absolutePosition.z)],
      radius: isRoomLink ? 0.01 : 0.025
    }, scene);

    var linkMaterial = _this.getMaterial('node-material', _this.nodeColor);

    linkMesh.material = linkMaterial;
    linkMesh.setParent(parent);
    linkMesh.isPickable = true;

    _this.log('Create Link Mesh', {
      assetName1: assetName1,
      assetName2: assetName2,
      linkMesh: linkMesh
    });

    return linkMesh;
  };

  this.createLink = function () {
    for (var _len2 = arguments.length, assets = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      assets[_key2] = arguments[_key2];
    }

    _this.log('Create Link', {
      assets: assets
    });

    var scene = _this.scene;
    assets.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
    var asset1 = assets[0],
        asset2 = assets[1];
    var node1 = scene.allNodes.find(function (node) {
      return node.nodeId === asset1.name;
    });
    var node2 = scene.allNodes.find(function (node) {
      return node.nodeId === asset2.name;
    });

    if (!node1 && !node2) {
      return {
        message: 'Cannot link two rooms',
        success: false
      };
    }

    if (node1) {
      if (node1.targetNodes.includes(asset2.name) || node1.targetAssets.includes(asset2.name)) {
        return {
          message: 'Assets already linked',
          success: false
        };
      }

      if (node2) {
        node1.targetNodes.push(node2.nodeId);
      } else {
        var alreadyLinkedNode = _pathfinding["default"].getNodeLinkedToAsset(asset2.name, scene.allNodes);

        if (alreadyLinkedNode) {
          return {
            message: "".concat(asset2.name, " already linked to ").concat(alreadyLinkedNode.nodeId),
            success: false
          };
        }

        node1.targetAssets.push(asset2.name);
      }
    }

    if (node2) {
      if (node2.targetNodes.includes(asset1.name) || node2.targetAssets.includes(asset1.name)) {
        return {
          message: 'Assets already linked',
          success: false
        };
      }

      if (node1) {
        node2.targetNodes.push(node1.nodeId);
      } else {
        var _alreadyLinkedNode = _pathfinding["default"].getNodeLinkedToAsset(asset1.name, scene.allNodes);

        if (_alreadyLinkedNode) {
          return {
            message: "".concat(asset1.name, " already linked to ").concat(_alreadyLinkedNode.nodeId),
            success: false
          };
        }

        node2.targetAssets.push(asset1.name);
      }
    }

    var _this$createLinkMesh = _this.createLinkMesh(asset1.name, asset2.name),
        linkName = _this$createLinkMesh.name;

    if (!linkName) {
      return;
    }

    scene.links.push(linkName);
    return {
      message: "Created link between ".concat(asset1.name, " and ").concat(asset2.name),
      success: true
    };
  };

  this.splitLink = function (asset, linkName, nodeName, position) {
    var _linkName$split$1$spl = linkName.split('link-')[1].split('|').filter(function (name) {
      return name;
    }).map(function (name) {
      return _this.scene.getMeshByName(name);
    }),
        _linkName$split$1$spl2 = _slicedToArray(_linkName$split$1$spl, 2),
        link1 = _linkName$split$1$spl2[0],
        link2 = _linkName$split$1$spl2[1]; // let centerPoint = BABYLON.Vector3.Lerp(link1.getAbsolutePosition(), link2.getAbsolutePosition(), 0.5)
    // Create new node in center of link


    _this.addNode({
      id: nodeName,
      position: position,
      floor: link1.parent.name
    }, false); // Remove link between link1 and link2


    _this.removeLink(link1, link2); // Add links between previously linked nodes and new node


    _this.createLink(link1, {
      name: nodeName
    });

    _this.createLink(link2, {
      name: nodeName
    }); // Add link between asset and newNode


    _this.createLink(asset, {
      name: nodeName
    });

    return {
      success: true,
      message: "Split link between ".concat(link1.name, " and ").concat(link2.name)
    };
  };

  this.unsplitLink = function (linkName, nodeName) {
    var _linkName$split$1$spl3 = linkName.split('link-')[1].split('|').filter(function (name) {
      return name;
    }).map(function (name) {
      return _this.scene.getMeshByName(name);
    }),
        _linkName$split$1$spl4 = _slicedToArray(_linkName$split$1$spl3, 2),
        link1 = _linkName$split$1$spl4[0],
        link2 = _linkName$split$1$spl4[1];

    _this.removeNode(nodeName);

    _this.createLink(link1, link2);
  };

  this.removeLink = function () {
    for (var _len3 = arguments.length, assets = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      assets[_key3] = arguments[_key3];
    }

    _this.log('Remove Link', {
      assets: assets
    });

    var scene = _this.scene;
    assets.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
    var asset1 = assets[0],
        asset2 = assets[1];
    var node1 = scene.allNodes.find(function (node) {
      return node.nodeId === asset1.name;
    });
    var node2 = scene.allNodes.find(function (node) {
      return node.nodeId === asset2.name;
    });

    if (node1) {
      node1.targetNodes = node1.targetNodes.filter(function (node) {
        return node !== asset2.name;
      });
      node1.targetAssets = node1.targetAssets.filter(function (asset) {
        return asset !== asset2.name;
      });
    }

    if (node2) {
      node2.targetNodes = node2.targetNodes.filter(function (node) {
        return node !== asset1.name;
      });
      node2.targetAssets = node2.targetAssets.filter(function (asset) {
        return asset !== asset1.name;
      });
    }

    var linkName = "link-|".concat(asset1.name, "|").concat(asset2.name, "|");
    var removedLinkMesh = scene.getMeshByName(linkName);

    if (removedLinkMesh) {
      removedLinkMesh.dispose();
    }

    scene.links = scene.links.filter(function (link) {
      return link !== linkName;
    });
  };

  this.removeMeshFromHighlights = function () {
    for (var _len4 = arguments.length, assetNames = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      assetNames[_key4] = arguments[_key4];
    }

    // this.log('Removing highlights', assetNames)
    assetNames.map(function (asset) {
      return _this.scene.getMeshByName(asset);
    }).filter(function (mesh) {
      return mesh;
    }).forEach(function (mesh) {
      return SceneWrapper.disableHighlight(mesh);
    });
  };

  this.showLinks = function (asset) {
    var scene = _this.scene;
    var assetNode = scene.allNodes.find(function (node) {
      return node.nodeId === asset.name;
    });

    var linkedNode = _pathfinding["default"].getNodeLinkedToAsset(asset.name, scene.allNodes);

    _this.log('Showing links', {
      assetNode: assetNode,
      linkedNode: linkedNode
    });

    if (!assetNode && !linkedNode) {
      return;
    }

    asset.showingLinks = true;
    var foundNode = scene.allNodes.find(function (node) {
      return node.nodeId === asset.name;
    }) || {
      nodeId: asset.name,
      targetNodes: [_pathfinding["default"].getNodeLinkedToAsset(asset.name, scene.allNodes).nodeId],
      targetAssets: []
    };
    var targets = [].concat(_toConsumableArray(foundNode.targetNodes), _toConsumableArray(foundNode.targetAssets));
    targets.forEach(function (id) {
      var assetList = [id, foundNode.nodeId];
      assetList.sort(function (a, b) {
        return a.localeCompare(b);
      });
      var linkName = "link-|".concat(assetList[0], "|").concat(assetList[1], "|");
      var linkMesh = scene.getMeshByName(linkName);

      if (linkMesh) {
        linkMesh.visibility = true;
        linkMesh.isPickable = true;
      } else {
        linkMesh = _this.createLinkMesh.apply(_this, assetList);
        scene.links.push(linkName);
      }
    });
  };

  this.hideLinks = function (asset) {
    _this.log('Hiding links', {
      asset: asset
    });

    var scene = _this.scene;
    var assetLinks = scene.links.filter(function (linkName) {
      return linkName.includes(asset.name);
    });
    assetLinks.forEach(function (linkToHide) {
      var linkMesh = scene.getMeshByName(linkToHide);

      if (linkMesh) {
        linkMesh.dispose();
        scene.links = scene.links.filter(function (linkName) {
          return linkName !== linkToHide;
        });
      }
    });
    asset.showingLinks = false;
  };

  this.updateLastNode = function (id, floor) {
    _this.log('Updated last node', id, floor);

    if (_this.lastNode) {
      var nodeMesh = _this.scene.getMeshByName(_this.lastNode.id);

      var nodeMaterial = _this.getMaterial('node-material', _this.nodeColor);

      if (nodeMesh) {
        nodeMesh.material = nodeMaterial;
      }
    }

    _this.lastNode = {
      id: id,
      floor: floor
    };
  };

  this.addNode = function (node) {
    var linkPreviousNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var id = node.id,
        position = node.position,
        _node$targetNodes = node.targetNodes,
        targetNodes = _node$targetNodes === void 0 ? [] : _node$targetNodes,
        _node$targetAssets = node.targetAssets,
        targetAssets = _node$targetAssets === void 0 ? [] : _node$targetAssets,
        floor = node.floor,
        floorRotation = node.floorRotation,
        _node$assetType = node.assetType,
        assetType = _node$assetType === void 0 ? [] : _node$assetType,
        customType = node.customType;

    _this.log("Adding node \"".concat(id, "\" at position"), position, floorRotation);

    if (customType) {
      assetType.push(customType);
    }

    var realPosition = new BABYLON.Vector3(position.x, position.y, position.z);
    var scene = _this.scene,
        nodeSize = _this.nodeSize,
        mode = _this.mode;
    var floorMesh = scene.getMeshByName(floor);

    if (floorMesh && floorRotation !== undefined) {
      floorMesh.rotation.y = floorRotation;
    }

    var nodeMesh;

    if (mode === 'development') {
      nodeMesh = BABYLON.MeshBuilder.CreateSphere(id, {
        diameter: 0.16 * nodeSize,
        slice: 0.5
      }, scene);
      var nodeMaterial = config ? _this.getMaterial('node-material', _this.nodeColor) : _this.getMaterial('prev-node', '#A0837F');
      nodeMesh.material = nodeMaterial;
      nodeMesh.position = realPosition;
    } else {
      nodeMesh = new BABYLON.TransformNode(id);
      nodeMesh.position = realPosition;
    }

    if (floorMesh) {
      nodeMesh.setParent(floorMesh);
    }

    var xAdjusted = position.x - floorMesh.position.x;
    var yAdjusted = position.y - floorMesh.position.y;
    var zAdjusted = position.z - floorMesh.position.z;
    var aNode = {
      nodeId: id,
      position: new BABYLON.Vector3(xAdjusted, yAdjusted, zAdjusted),
      targetNodes: targetNodes,
      targetAssets: targetAssets,
      nodeType: 'node',
      floor: floor,
      floorRotation: floorRotation || _this.cachedRotationValues[floor],
      assetType: assetType
    };
    scene.nodeCount = Math.max(scene.nodeCount, parseInt(id.split('-')[1], 10)) + 1;
    scene.allNodes.push(_objectSpread({}, aNode));

    if (linkPreviousNode && _this.lastNode && _this.lastNode.floor === floor) {
      _this.createLink({
        name: id
      }, {
        name: _this.lastNode.id
      });
    }

    if (!config) {
      _this.updateLastNode(id, floor);
    }
  };

  this.addInitialNode = function (node) {
    _this.log('Adding initial node', {
      node: node
    });

    var id = node.id,
        position = node.position,
        _node$targetNodes2 = node.targetNodes,
        targetNodes = _node$targetNodes2 === void 0 ? [] : _node$targetNodes2,
        _node$targetAssets2 = node.targetAssets,
        targetAssets = _node$targetAssets2 === void 0 ? [] : _node$targetAssets2,
        _node$terminalID = node.terminalID,
        terminalID = _node$terminalID === void 0 ? '' : _node$terminalID,
        _node$orientation = node.orientation,
        orientation = _node$orientation === void 0 ? '0' : _node$orientation,
        floor = node.floor,
        floorRotation = node.floorRotation;
    var realPosition = new BABYLON.Vector3(position.x, position.y, position.z);
    var scene = _this.scene,
        nodeSize = _this.nodeSize,
        mode = _this.mode;
    var floorMesh = scene.getMeshByName(floor);
    var nodeRotation = floorMesh && floorMesh.rotation.y || 0;

    if (floorMesh && floorRotation) {
      floorMesh.rotation.y = floorRotation;
    }

    var nodeMesh;

    if (mode === 'development') {
      var pointArray = _this.getInitialNodePointArray();

      var triangles = new BABYLON.PolygonMeshBuilder('triangles', pointArray, scene, require('earcut'));
      nodeMesh = triangles.build(false, 0.08 * nodeSize);
      nodeMesh.name = id;

      var nodeMaterial = _this.getMaterial('node-material-new', '#A0837F');

      nodeMesh.material = nodeMaterial;
      nodeMesh.position = realPosition;
      nodeMesh.position.y += 0.08 * nodeSize;
      nodeMesh.rotation.y = nodeRotation + Math.PI / 2 + Number(orientation) * (Math.PI / 180);
    } else {
      nodeMesh = new BABYLON.TransformNode(id);
      nodeMesh.position = realPosition;
    }

    if (floorMesh) {
      nodeMesh.setParent(floorMesh);
    }

    var xAdjusted = position.x - floorMesh.position.x;
    var yAdjusted = position.y - floorMesh.position.y;
    var zAdjusted = position.z - floorMesh.position.z;
    scene.nodeCount = Math.max(scene.nodeCount, parseInt(id.split('-').pop(), 10)) + 1; // Add initial point to allNodes so it gets hidden later

    var aNode = {
      nodeId: id,
      nodeType: 'initialNode',
      position: new BABYLON.Vector3(xAdjusted, yAdjusted, zAdjusted),
      targetNodes: targetNodes,
      targetAssets: targetAssets,
      orientation: orientation,
      terminalID: terminalID,
      floor: floor,
      floorRotation: floorRotation || _this.cachedRotationValues[floor]
    };
    scene.allNodes.push(aNode);

    _this.updateLastNode(id, floor);
  };

  this.updateTerminalOrientation = function (orientation, terminal) {
    if (terminal.name.includes('youRhere')) {
      var newRotation = (Number(orientation) * (Math.PI / 180) + Math.PI / 2) % (Math.PI * 2);
      var north = _this.scene.cameraNorth;
      terminal.rotation.y = newRotation - north;
    } else {
      var labelMesh = _this.scene.getMeshByName(terminal.name + '-text') || _this.scene.getMeshByName(terminal.name + '-logo');

      if (labelMesh) {
        labelMesh.rotation.y = Number(orientation) * (Math.PI / 180) - Math.PI / 2;
      }
    }
  };

  this.removeNode = function (idToRemove) {
    _this.log('Removing node', {
      idToRemove: idToRemove
    });

    var scene = _this.scene;
    var nodeMesh = scene.getMeshByName(idToRemove);

    _this.removeLinksFromNode(idToRemove);

    if (nodeMesh) {
      nodeMesh.dispose();
    }

    scene.allNodes = scene.allNodes.filter(function (node) {
      return node.nodeId !== idToRemove;
    });
  };

  this.resizeNode = function (node, nodeSize) {
    _this.log('Resizing node', {
      node: node
    });

    var _node$orientation2 = node.orientation,
        orientation = _node$orientation2 === void 0 ? '0' : _node$orientation2,
        name = node.nodeId;

    var mesh = _this.scene.getMeshByName(name);

    var position = mesh.position,
        material = mesh.material,
        parent = mesh.parent,
        y = mesh.rotation.y;
    var newNode;
    var floorRotation = parent.rotation.y;
    mesh.dispose();

    if (node.nodeType === 'initialNode') {
      var pointArray = _this.getInitialNodePointArray();

      var triangles = new BABYLON.PolygonMeshBuilder('triangles', pointArray, _this.scene, require('earcut'));
      newNode = triangles.build(false, 0.08 * nodeSize);
      newNode.rotation.y = floorRotation + Math.PI / 2 + Number(orientation) * (Math.PI / 180);
      newNode.name = name;
    } else {
      newNode = BABYLON.MeshBuilder.CreateSphere(name, {
        diameter: 0.16 * nodeSize,
        slice: 0.5
      }, _this.scene);
    }

    if (parent) {
      newNode.setParent(parent);
    }

    newNode.position = position;
    newNode.material = material;
  };

  this.adjustGizmoSize = function (newSize) {
    var positionGizmo = _this.scene.dragHandler.gizmos.positionGizmo;
    positionGizmo.scaleRatio = newSize * 0.05;
  };

  this.recolorNodes = function (nodeColor) {
    _this.nodeColor = nodeColor;

    var nodeMaterial = _this.scene.getMaterialByName('node-material');

    if (!nodeMaterial) {
      return;
    }

    nodeMaterial.diffuseColor = new BABYLON.Color3.FromHexString(nodeColor);
  };

  this.removeLinksFromNode = function (id) {
    _this.log('Removing links from node', {
      id: id
    });

    var scene = _this.scene;
    var firstMesh = scene.getMeshByName(id);
    var sceneNode = scene.allNodes.find(function (node) {
      return node.nodeId === id;
    });
    var linkedAssets = [];

    if (sceneNode) {
      var targetNodes = sceneNode.targetNodes,
          targetAssets = sceneNode.targetAssets;
      linkedAssets = [].concat(_toConsumableArray(targetNodes), _toConsumableArray(targetAssets));
    } else {
      var linkedNode = _pathfinding["default"].getNodeLinkedToAsset(id, scene.allNodes);

      linkedAssets = linkedNode ? [linkedNode.nodeId] : [];
    }

    linkedAssets.forEach(function (linkedId) {
      var linkedAsset = scene.getMeshByName(linkedId);

      if (linkedAsset) {
        _this.removeLink(linkedAsset, firstMesh);
      }
    });
    scene.links = scene.links.filter(function (link) {
      return !link.includes(id);
    });
    return linkedAssets.map(function (linkedId) {
      return {
        name: linkedId
      };
    });
  };

  this.testAllPaths = function () {
    return new Promise(function (resolve) {
      _this.log('Testing all paths');

      var promises = [];
      var startPoint = _this.scene.assets[0];

      _this.scene.assets.forEach(function (destination) {
        if (startPoint !== destination) {
          _this.pathfinding.accessibilityOnly = false;
          promises.push(_this.testPath({
            start: startPoint.assetId,
            end: destination.assetId
          }));
          _this.pathfinding.accessibilityOnly = true;
          promises.push(_this.testPath({
            start: startPoint.assetId,
            end: destination.assetId
          }));
        }
      });

      Promise.all(promises).then(function (results) {
        _this.pathfinding.accessibilityOnly = false;

        if (results.every(function (res) {
          return res.success;
        })) {
          resolve({
            message: 'All assets connected',
            type: 'info'
          });
        } else {
          console.warn('Assets not linked: ');
          console.warn(results.filter(function (res) {
            return !res.success;
          }));
          resolve({
            message: 'Some assets not linked. See console for details.',
            type: 'error'
          });
        }
      });
    });
  };

  this.testPath = function (route) {
    return new Promise(function (resolve) {
      _this.log('Testing path', {
        route: route
      });

      var pathfinding = _this.pathfinding;

      _this.resetScene();

      var start = route.start,
          end = route.end;

      if (!start) {
        resolve({
          message: 'No start point',
          success: false
        });
      }

      if (!end) {
        resolve({
          message: 'No end point',
          success: false
        });
      }

      var _pathfinding$djikstra = pathfinding.djikstra(start, end),
          success = _pathfinding$djikstra.success,
          message = _pathfinding$djikstra.message;

      if (success) {
        resolve({
          success: true
        });
      } else {
        resolve({
          message: "Pathfinding failed between ".concat(start, " and ").concat(end, ", Accessibility Mode: ").concat(pathfinding.accessibilityOnly),
          success: success
        });
      }
    });
  };

  this.createPath = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(route) {
      var pathfinding, start, end, startNode, orientation, _pathfinding$djikstra2, success, message, path, usedFloors, modifiedPath, longSideOfPath;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.log('Creating path', {
                route: route
              });

              pathfinding = _this.pathfinding;
              start = route.start, end = route.end;
              startNode = _this.scene.allNodes.find(function (node) {
                return node.nodeType === 'initialNode' && node.terminalID === "".concat(start);
              });
              orientation = startNode && startNode.orientation;

              if (start) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", {
                message: 'No start point',
                success: false
              });

            case 7:
              if (end) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", {
                message: 'No end point',
                success: false
              });

            case 9:
              _pathfinding$djikstra2 = pathfinding.djikstra(startNode && startNode.nodeId || start, end), success = _pathfinding$djikstra2.success, message = _pathfinding$djikstra2.message, path = _pathfinding$djikstra2.path;

              if (!success) {
                _context.next = 16;
                break;
              }

              _this.log('Found path');

              if (_this.mode === 'production') {
                usedFloors = _this.getUsedFloors(path);
                modifiedPath = path.map(function (point) {
                  var pointMesh = _this.scene.getMeshByName(point.nodeId) || _this.scene.getNodeByName(point.nodeId);

                  return _objectSpread(_objectSpread({}, point), {}, {
                    pointMesh: pointMesh,
                    position: pointMesh.getAbsolutePosition()
                  });
                }); // Hide meshes on unused floors

                _this.setActiveFloor(usedFloors); // Rotate camera to show the route


                longSideOfPath = SceneWrapper.getLongSide(modifiedPath); // this.setCamera(longSideOfPath, orientation)
                // Highlight start and end mesh

                _this.addMeshToHighlights(_this.primaryHighlight, true, start, end);
              }

              _context.next = 15;
              return pathfinding.pathRenderer.renderPath(_toConsumableArray(path));

            case 15:
              return _context.abrupt("return", {
                message: "Found path between ".concat(start, " and ").concat(end),
                success: true
              });

            case 16:
              return _context.abrupt("return", {
                message: message,
                success: success
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref10.apply(this, arguments);
    };
  }();

  this.hideFloors = function (floors) {
    _this.log('Hiding floors', {
      floors: floors
    });

    var meshes = _this.scene.meshes;
    meshes.forEach(function (mesh) {
      var visible = true;
      var pickable = !mesh.id.includes('-text');
      floors.forEach(function (floorName) {
        if (mesh.name.includes(floorName)) {
          visible = false;
          pickable = false;
        }
      });
      mesh.visibility = visible;
      mesh.isPickable = pickable;
    });
  };

  this.setCamera = function (longSide, orientation) {
    var scene = _this.scene;
    var finalRotation = -(Number(orientation) * (Math.PI / 180)) + _this.scene.cameraNorth;

    _this.log('Setting camera', {
      longSide: longSide,
      orientation: orientation,
      scene: scene,
      finalRotation: finalRotation
    });

    var firstTarget;
    var firstCenter;
    var firstDir;
    var firstHeight; // For each floor in this path, set the floor's pivot point to the center of the path.

    longSide.forEach(function (_ref11) {
      var floor = _ref11.floor,
          side = _ref11.side;
      var pointA = side.pointA,
          pointB = side.pointB,
          distance = side.distance;
      var delta = {};
      var dir = {};
      var center = {};
      ['x', 'y', 'z'].forEach(function (axis) {
        delta[axis] = pointB.position[axis] - pointA.position[axis];
        dir[axis] = delta[axis] / distance;
        center[axis] = pointA.position[axis] + delta[axis] * 0.5;
      });
      var targetPoint = new BABYLON.Vector3(center.x, center.y, center.z);
      var floorMesh = scene.getMeshByName(floor);
      floorMesh.setPivotPoint(targetPoint, BABYLON.Space.WORLD);
      floorMesh.rotation.y = finalRotation;

      _this.setRotation(finalRotation);

      firstTarget = firstTarget || targetPoint;
      firstCenter = firstCenter || center;
      firstDir = firstDir || dir;
      firstHeight = firstHeight || 1.5 * (Math.sqrt(3) / 2 * distance);
    });
    scene.camera.panningOriginTarget = firstTarget.clone();
    scene.camera.target = firstTarget.clone();
    scene.camera.beta = Math.PI / 4;
  };

  this.renderLoop = function () {
    _this.markerToRenderLoop.forEach(function (mesh) {
      var sceneEngine = _this.scene.sceneEngine;

      var meshPosition = _objectSpread({}, mesh.getAbsolutePosition());

      if (mesh.isFloor) {
        meshPosition._z -= _this.floorLabelOffset * _this.floorLabelOffsetMult;
      }

      var newRay = new BABYLON.Ray(_this.scene.activeCamera.position, new BABYLON.Vector3(meshPosition._x - _this.scene.activeCamera.position.x, meshPosition._y - _this.scene.activeCamera.position.y, meshPosition._z - _this.scene.activeCamera.position.z));

      var pick = _this.scene.pickWithRay(newRay, function () {
        return true;
      });

      var isVisible = mesh.isFloor || pick && pick.pickedMesh === mesh;
      var pos = BABYLON.Vector3.Project(meshPosition, BABYLON.Matrix.IdentityReadOnly, _this.scene.getTransformMatrix(), _this.scene.camera.viewport.toGlobal(sceneEngine.getRenderWidth(), sceneEngine.getRenderHeight()));

      if (!pos.hasOwnProperty('_x') || !pos.hasOwnProperty('_y') || isNaN(pos._x) || isNaN(pos._y)) {
        return;
      }

      _this.handleFlyout(mesh.name, {
        x: pos._x,
        y: pos._y
      }, false, {
        isVisible: isVisible
      });
    });

    _this.scene.render();
  };

  this.clearNodes = function () {
    _this.log('Clearing all nodes');

    var scene = _this.scene;
    scene.allNodes.forEach(function (node) {
      _this.removeNode(node.nodeId);
    });
  };

  this.resetScene = function () {
    var keepFloors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _this.log('Resetting scene'); // remove path mesh


    _this.meshList.forEach(function (mesh) {
      mesh.dispose();
    });

    if (!keepFloors) {
      _this.setActiveFloor(_this.scene.floors.map(function (f) {
        return f.name;
      }));
    } // Unhighlight all rooms


    [].concat(_toConsumableArray(_this.highlights), _toConsumableArray(_this.tempHighlights)).forEach(function (mesh) {
      SceneWrapper.disableHighlight(mesh);
    });
    _this.highlights = [];
    _this.tempHighlights = [];
    _this.markerToRenderLoop = [];
  };

  this.getValidAssets = function (onlyCMSAssets) {
    // An asset is valid if there is a node that connects to it
    if (_this.scene && _this.scene.assets) {
      if (_this.mode === 'production') {
        if (onlyCMSAssets) {
          return _toConsumableArray(_this.scene.assets.filter(function (a) {
            return a.cms;
          }).sort(function (a, b) {
            return a.assetId.localeCompare(b.assetId);
          }));
        }

        return _toConsumableArray(_this.scene.assets.sort(function (a, b) {
          return a.assetId.localeCompare(b.assetId);
        }));
      }

      var links = _this.scene.links.map(function (l) {
        var lMesh = _this.scene.getMeshByName(l);

        return {
          assetId: l,
          position: lMesh && lMesh.position
        };
      });

      return [].concat(_toConsumableArray(links), _toConsumableArray(_this.scene.assets.sort(function (a, b) {
        return a.assetId.localeCompare(b.assetId);
      })), _toConsumableArray(_this.scene.allNodes.map(function (node) {
        return {
          assetId: node.nodeId,
          position: node.position
        };
      })));
    }

    return [];
  };

  this.clearTempHighlights = function () {
    _this.tempHighlights.forEach(function (mesh) {
      SceneWrapper.disableHighlight(mesh);
    });

    _this.tempHighlights = [];
  };

  this.setFloorSpace = function (floorSpace) {
    _this.floorSpace = floorSpace;

    _this.setActiveFloor(_this.activeFloors);
  };

  this.setFloorOrder = function (order) {
    _this.log('Setting floor order', {
      order: order
    });

    if (order) {
      _this.scene.floors = _toConsumableArray(order);

      _this.setActiveFloor(_this.activeFloors);
    }
  };

  this.removeActiveTenant = function (cmsID) {
    var asset = _this.scene.assets.find(function (a) {
      return a.cmsID && a.cmsID.toUpperCase() === cmsID.toUpperCase();
    });

    if (!asset) {
      return;
    }

    var assetId = asset.assetId;

    _this.removeMeshFromHighlights(assetId);

    _this.handleFlyout(assetId, false);

    var mesh = _this.scene.getMeshByName(assetId);

    if (!mesh) {
      return;
    } // Remove mesh from flyouts and render loop


    _this.markerToRenderLoop = _this.markerToRenderLoop.filter(function (m) {
      return m !== mesh;
    });
  };

  this.setActiveTenant = function (cmsID, centerCamera, shouldAnimate) {
    var asset = _this.scene.assets.find(function (a) {
      return a.cmsID && a.cmsID.toUpperCase() === cmsID.toUpperCase();
    });

    if (!asset) {
      return;
    }

    var assetId = asset.assetId,
        cms = asset.cms,
        displayName = asset.displayName;

    var mesh = _this.scene.getMeshByName(assetId);

    if (!mesh) {
      return;
    } // Force mesh to recompute position after setting active floor


    mesh.computeWorldMatrix(true);

    if (centerCamera) {
      if (shouldAnimate) {
        var axis = ['x', 'y', 'z'];
        var ease = new BABYLON.CubicEase();
        ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
        var currPos = _this.scene.activeCamera.target;
        var nextPos = mesh.getAbsolutePosition();
        _this.scene.activeCamera.animations = axis.map(function (a) {
          var from = currPos[a];
          var to = nextPos[a];
          var animation = BABYLON.Animation.CreateAnimation("target.".concat(a), BABYLON.Animation.ANIMATIONTYPE_FLOAT, 60, ease);
          animation.setKeys([{
            frame: 0,
            value: from
          }, {
            frame: 30,
            value: to
          }]);
          return animation;
        });

        _this.scene.beginAnimation(_this.scene.activeCamera, 0, 30, false, 4);
      } else {
        var _mesh$getAbsolutePosi = mesh.getAbsolutePosition(),
            x = _mesh$getAbsolutePosi.x,
            y = _mesh$getAbsolutePosi.y,
            z = _mesh$getAbsolutePosi.z;

        _this.scene.activeCamera.setTarget(new BABYLON.Vector3(x, y, z));
      }
    }

    _this.addMeshToHighlights(_this.primaryHighlight, true, assetId);

    _this.pathfinding.pathRenderer.flatFlyout({
      id: assetId,
      position: mesh.position,
      text: cms ? cms.name : displayName,
      type: 'destination',
      mesh: mesh
    });
  };

  this.setActiveFloor = function () {
    var activeFloors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var loaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _this.log('Setting active floor', {
      activeFloors: activeFloors
    });

    if (!activeFloors.length) {
      _this.activeFloors = _toConsumableArray(_this.scene.floors.map(function (f) {
        return f.name;
      }));
    } else {
      _this.activeFloors = _toConsumableArray(activeFloors);
    }

    _this.scene.meshes.forEach(function (mesh) {
      var sceneNode = _this.scene.allNodes.find(function (n) {
        return n.nodeId === mesh.name;
      });

      var meshFloor = (0, _getFloorFromName["default"])(mesh.name) || mesh.parent && mesh.parent.id;
      mesh.visibility = false;
      mesh.isPickable = false;

      var nodeBelongsToFloor = sceneNode && _this.activeFloors.includes(sceneNode.floor);

      var belongsToFloor = _this.activeFloors.includes(meshFloor) || _this.activeFloors.includes(mesh.name) || nodeBelongsToFloor;

      if (belongsToFloor) {
        if (sceneNode) {
          if (_this.mode === 'production') {
            mesh.visibility = false;
          }
        }

        mesh.visibility = true;
        mesh.isPickable = nodeBelongsToFloor || _this.reservedWords.some(function (w) {
          return mesh.id.toLowerCase().includes(w.toLowerCase());
        }) && !mesh.id.toLowerCase().includes('logo');
      }
    });

    var prevFloor;

    var orderedFloors = _this.activeFloors.map(function (af) {
      return _this.scene.floors.find(function (f) {
        return f.name === af;
      });
    }).sort(function (a, b) {
      return a.order - b.order;
    });

    var floorGap = Math.max.apply(Math, _toConsumableArray(orderedFloors.map(function (o) {
      var floorMesh = _this.scene.getMeshByName(o.name);

      if (!floorMesh) {
        console.warn('Failed to get floor mesh for mesh:', o.name);
        return 0;
      }

      var extendSize = floorMesh.getBoundingInfo().boundingBox.extendSize;
      return extendSize.x;
    })));
    orderedFloors.forEach(function (floor) {
      var floorMesh = _this.scene.getMeshByName(floor.name);

      if (!floorMesh) {
        console.warn('Failed to get floor mesh for mesh:', o.name);
        return;
      }

      var extendSize = floorMesh.getBoundingInfo().boundingBox.extendSize;
      var newPosition;

      if (!prevFloor) {
        newPosition = new BABYLON.Vector3(0, 0, 0);
      } else {
        newPosition = new BABYLON.Vector3(prevFloor.x - prevFloor.xDim - extendSize.x, prevFloor.y + floorGap * _this.floorSpace, prevFloor.z);
      }

      floorMesh.position = newPosition;
      floorMesh.isPickable = true;
      prevFloor = {
        x: newPosition.x,
        y: newPosition.y,
        z: newPosition.z,
        xDim: extendSize.x,
        zDim: extendSize.z
      };
    });

    if (loaded && _this.activeAmenities && _this.activeAmenities.length) {
      _this.highlightAmenities();
    }
  };

  this.getUsedFloors = function (path) {
    var allFloors = [];
    path.forEach(function (node) {
      var floor = node.floor || (0, _getFloorFromName["default"])(node.nodeId);

      if (!allFloors.includes(floor)) {
        allFloors.push(floor);
      }
    });

    _this.log('Get Used Floors', {
      path: path,
      allFloors: allFloors
    });

    return allFloors;
  };

  this.overHeadView = function () {
    _this.scene.camera.beta = 0;

    _this.scene.floors.forEach(function (_ref12) {
      var name = _ref12.name;

      var m = _this.scene.getMeshByName(name);

      if (!m) {
        return;
      }

      m.rotation.y = 0;
      _this.cachedRotationValues[name] = 0;
    });
  };

  this.parseLogo = function (url) {
    var newURL = "/public/data/logos/".concat(url.split('/').pop());

    _this.log('Parsing logo', {
      url: url,
      newURL: newURL
    });

    return newURL;
  };

  this.getImageDimensions = function (url) {
    return new Promise(function (resolve, reject) {
      var myImage = new Image();
      myImage.src = url;

      myImage.onload = function () {
        var height = myImage.height,
            width = myImage.width;
        resolve({
          height: height,
          width: width
        });
      };

      myImage.onerror = function () {
        reject('Image error', url);
      };
    });
  };

  this.moveCameraToPosition = function (position, target) {
    var ghostCam = new BABYLON.ArcRotateCamera("ghostCam", 0, 0, 0, position, _this.scene);
    ghostCam.setTarget(target);

    _this.scene.cameras.pop();

    var alphaAnimation = new BABYLON.Animation("camAlpha", "alpha", 30, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT);
    var betaAnimation = new BABYLON.Animation("camBeta", "beta", 30, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT); // reseting the alpha and beta to a much simpler version

    _this.scene.camera.alpha = _this.scene.camera.alpha % (Math.PI * 2);
    _this.scene.camera.beta = _this.scene.camera.beta % (Math.PI * 2);

    if (_this.scene.camera.alpha < 0) {
      _this.scene.camera.alpha += Math.PI * 2;
    }

    if (_this.scene.camera.beta < 0) {
      _this.scene.camera.beta += Math.PI * 2;
    } // used to find the shortest curve IE. if angle == 3PI/2 => take the -1PI/2 instead


    var alpha = ghostCam.alpha;

    if (Math.abs(_this.scene.camera.alpha - alpha) > Math.PI) {
      alpha = ghostCam.alpha + Math.PI * 2;
    }

    var beta = ghostCam.beta;

    if (Math.abs(_this.scene.camera.beta - beta) > Math.PI) {
      beta = ghostCam.beta + Math.PI * 2;
    }

    var keys2 = [{
      frame: 0,
      value: _this.scene.camera.alpha
    }, {
      frame: 100,
      value: alpha
    }];
    var keys3 = [{
      frame: 0,
      value: _this.scene.camera.beta
    }, {
      frame: 100,
      value: beta
    }];
    alphaAnimation.setKeys(keys2);
    betaAnimation.setKeys(keys3);

    _this.scene.camera.animations.push(alphaAnimation);

    _this.scene.camera.animations.push(betaAnimation);

    _this.scene.beginAnimation(_this.scene.camera, 0, 100, false, 1);
  };

  this.hideAllNodes = function () {
    _this.log('Hide all nodes');

    _this.scene.allNodes.forEach(function (node) {
      if (['node', 'initialNode'].includes(node.nodeType)) {
        var nodeMesh = _this.scene.getMeshByName(node.nodeId);

        if (!nodeMesh) {
          return;
        }

        nodeMesh.visibility = false;
      }
    });
  };

  this.showAllNodes = function () {
    _this.log('Show all nodes');

    _this.scene.allNodes.forEach(function (node) {
      if (['node', 'initialNode'].includes(node.nodeType)) {
        var nodeMesh = _this.scene.getMeshByName(node.nodeId);

        if (!nodeMesh) {
          return;
        }

        var parent = nodeMesh.parent; // If this node's on a hidden floor, don't show it!

        if (_this.activeFloors.includes(parent.id)) {
          nodeMesh.visibility = true;
        }
      }
    });
  };

  this.showAllRoomLabels = function () {
    _this.log('Show all room labels');

    _this.scene.assets.filter(function (a) {
      var assetFloor = (0, _getFloorFromName["default"])(a.assetId);
      return _this.activeFloors.includes(assetFloor);
    }).forEach(function (a) {
      _this.pathfinding.pathRenderer.flatFlyout({
        id: a.assetId,
        text: a.assetId,
        type: 'roomLabel'
      });
    });

    _this.showingRoomLabels = true;
  };

  this.hideAllRoomLabels = function () {
    _this.log('Hide all room labels');

    _this.markerToRenderLoop = [];
    _this.showingRoomLabels = false;
  };

  this.showAllFloorLabels = function () {
    _this.log('Show all floor labels');

    if (_this.hideFloorLabels) {
      return;
    }

    _this.activeFloors.forEach(function (f) {
      _this.pathfinding.pathRenderer.flatFlyout({
        id: f,
        text: _this.floorLabels[f] || f,
        type: 'floorLabel'
      });
    });
  };

  this.hideAllFloorLabels = function () {
    _this.log('Hide all floor labels');

    _this.markerToRenderLoop = [];
  };

  this.placeLabel = function (_ref13) {
    var mesh = _ref13.mesh,
        width = _ref13.width,
        height = _ref13.height,
        orientation = _ref13.orientation,
        scale = _ref13.scale,
        material = _ref13.material,
        isText = _ref13.isText;
    var radRotation = Number(orientation) * (Math.PI / 180) - Math.PI / 2;
    var scaleLimit = isText ? _this.maxTextLabelSize : Infinity;
    var _mesh$getBoundingInfo = mesh.getBoundingInfo().boundingBox.extendSize,
        aX = _mesh$getBoundingInfo.x,
        aY = _mesh$getBoundingInfo.y,
        aZ = _mesh$getBoundingInfo.z;
    var rotX = Math.abs(width * Math.cos(radRotation)) + Math.abs(height * Math.sin(radRotation));
    var rotZ = Math.abs(height * Math.cos(radRotation)) + Math.abs(width * Math.sin(radRotation));
    var ratioX = aX / rotX;
    var ratioZ = aZ / rotZ;
    var realScale = Math.min(Math.min(ratioX, ratioZ) * (scale / 100), scaleLimit);
    var label = BABYLON.MeshBuilder.CreatePlane("".concat(mesh.id, "-logo"), {
      height: height * realScale,
      width: width * realScale
    }, _this.scene);
    label.material = material;
    label.isPickable = false;
    label.rotation.x = Math.PI / 2;
    label.rotation.y = radRotation;
    label.parent = mesh;
    label.position.y += aY * 2 + 0.01;

    _this.scene.markerMeshes.push(label);

    return label;
  };

  this.createTextLabel = function (_ref14) {
    var mesh = _ref14.mesh,
        texture = _ref14.texture,
        orientation = _ref14.orientation,
        scale = _ref14.scale,
        width = _ref14.width,
        height = _ref14.height;

    _this.log("Creating text logo for ".concat(mesh.id));

    var labelMaterial = new BABYLON.StandardMaterial("".concat(mesh.id, "LabelMat"), _this.scene);
    labelMaterial.diffuseTexture = texture;
    labelMaterial.specularColor = new BABYLON.Color3(0, 0, 0);
    labelMaterial.diffuseTexture.hasAlpha = true;
    return _this.placeLabel({
      mesh: mesh,
      width: width,
      height: height,
      orientation: orientation,
      scale: scale,
      material: labelMaterial,
      isText: true
    });
  };

  this.createImageLabel = /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref15) {
      var mesh, image, orientation, scale, labelMaterial, _yield$_this$getImage, height, width;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              mesh = _ref15.mesh, image = _ref15.image, orientation = _ref15.orientation, scale = _ref15.scale;

              _this.log("Creating image logo for ".concat(image));

              labelMaterial = new BABYLON.StandardMaterial("".concat(mesh.id, "LabelMat"), _this.scene);
              labelMaterial.diffuseTexture = new BABYLON.Texture(image, _this.scene);
              labelMaterial.specularColor = new BABYLON.Color3(0, 0, 0);
              labelMaterial.diffuseTexture.hasAlpha = true;
              _context2.prev = 6;
              _context2.next = 9;
              return _this.getImageDimensions(image);

            case 9:
              _yield$_this$getImage = _context2.sent;
              height = _yield$_this$getImage.height;
              width = _yield$_this$getImage.width;
              return _context2.abrupt("return", _this.placeLabel({
                mesh: mesh,
                width: width,
                height: height,
                orientation: orientation,
                scale: scale,
                material: labelMaterial
              }));

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](6);

              _this.log('Error creating label', _context2.t0);

              return _context2.abrupt("return");

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 15]]);
    }));

    return function (_x2) {
      return _ref16.apply(this, arguments);
    };
  }();

  this.showAllLabels = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Promise.all([_this.showTextLabels(), _this.showImageLabels()]);

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  this.showTextLabels = /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
      var lineLengthLimit, textPromises;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this.log('Show all text labels', _this.scene.assets);

              _this.timeStart('create text labels');

              lineLengthLimit = 10;
              textPromises = _this.scene.assets.filter(function (a) {
                var assetId = a.assetId,
                    displayName = a.displayName,
                    cmsID = a.cmsID,
                    showName = a.showName;

                if (showName) {
                  return true;
                }

                return assetId.toLowerCase().includes('marker') && (displayName || cmsID) && (!id || id === assetId);
              }).map(function (a) {
                _this.log('Creating label for asset ', a);

                var assetId = a.assetId,
                    displayName = a.displayName,
                    cmsID = a.cmsID,
                    _a$orientation = a.orientation,
                    orientation = _a$orientation === void 0 ? 0 : _a$orientation,
                    _a$scale = a.scale,
                    scale = _a$scale === void 0 ? 100 : _a$scale,
                    cms = a.cms;

                if (!(cms || displayName) && _this.mode === 'production') {
                  return Promise.resolve();
                }

                var assetMesh = _this.scene.getMeshByName(assetId);

                if (!assetMesh.visibility) {
                  return Promise.resolve();
                }

                var labelText; // Text is defined in the 3D editor

                if (!cms) {
                  labelText = displayName || "----".concat(cmsID, "----");
                } else {
                  labelText = cms[_this.labelKey] || cms.name;
                }

                labelText = labelText.toUpperCase();
                var labelWords = labelText.split(' ');
                var lines = [];
                var line = '';
                var len = 0;
                labelWords.forEach(function (w) {
                  line += w + ' ';
                  len += w.length;

                  if (len > lineLengthLimit) {
                    lines.push(line.trim());
                    line = '';
                    len = 0;
                  }
                });

                if (line.length) {
                  lines.push(line);
                } // Create or reuse a canvas element


                var canvasElement = document.getElementById('tempTextCanvas') || document.createElement('canvas');
                var ctx = canvasElement.getContext('2d');
                canvasElement.id = 'tempTextCanvas'; // Set the font before measuring

                var fontSize = 144;
                ctx.font = "".concat(fontSize, "px ").concat(_this.labelFont);
                ctx.textAlign = 'center';

                var _ctx$measureText = ctx.measureText(labelText),
                    actualBoundingBoxAscent = _ctx$measureText.actualBoundingBoxAscent,
                    actualBoundingBoxDescent = _ctx$measureText.actualBoundingBoxDescent;

                var lineHeight = (actualBoundingBoxAscent + actualBoundingBoxDescent) * 1.25;
                var totalHeight = lineHeight * lines.length;
                var maxWidth = Math.max.apply(Math, _toConsumableArray(lines.map(function (l) {
                  ctx.font = "".concat(fontSize, "px ").concat(_this.labelFont);
                  ctx.textAlign = 'center';

                  var _ctx$measureText2 = ctx.measureText(l),
                      actualBoundingBoxLeft = _ctx$measureText2.actualBoundingBoxLeft,
                      actualBoundingBoxRight = _ctx$measureText2.actualBoundingBoxRight,
                      width = _ctx$measureText2.width;

                  return Math.max(width, actualBoundingBoxLeft + actualBoundingBoxRight);
                })));
                ctx.canvas.width = maxWidth;
                ctx.canvas.height = totalHeight + 25;
                ctx.font = "".concat(fontSize, "px ").concat(_this.labelFont);
                ctx.textAlign = 'center';
                lines.forEach(function (l, idx) {
                  ctx.fillText(l, maxWidth / 2, lineHeight * (idx + 1));
                });
                var texture = new BABYLON.HtmlElementTexture(labelText, ctx.canvas, {
                  scene: _this.scene
                });
                return _this.createTextLabel({
                  mesh: assetMesh,
                  texture: texture,
                  orientation: orientation,
                  scale: scale * 1.4,
                  width: maxWidth,
                  height: totalHeight
                });
              });
              _context4.next = 6;
              return Promise.all(textPromises);

            case 6:
              _this.timeEnd('create text labels');

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x3) {
      return _ref18.apply(this, arguments);
    };
  }();

  this.showImageLabels = /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
      var imagePromises;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this.log('Show all image labels');

              _this.timeStart('create image labels');

              imagePromises = _this.scene.assets.filter(function (a) {
                var assetId = a.assetId,
                    imageSource = a.imageSource,
                    cmsID = a.cmsID,
                    showLogo = a.showLogo;

                if (showLogo) {
                  return true;
                }

                return assetId.toLowerCase().includes('marker') && (imageSource || cmsID) && (!id || id === assetId);
              }).map(function (a) {
                _this.log('Creating label for asset ', a);

                var assetId = a.assetId,
                    _a$orientation2 = a.orientation,
                    orientation = _a$orientation2 === void 0 ? 0 : _a$orientation2,
                    _a$scale2 = a.scale,
                    scale = _a$scale2 === void 0 ? 100 : _a$scale2,
                    imageSource = a.imageSource,
                    cms = a.cms;
                var noCMS = !cms || !cms[_this.logoKey];

                if (noCMS && !imageSource && _this.mode === 'production') {
                  return Promise.resolve();
                }

                var assetMesh = _this.scene.getMeshByName(assetId);

                if (!assetMesh.visibility) {
                  return Promise.resolve();
                }

                var imagePath = imageSource; // Show the placeholder if we don't have CMS data

                if (noCMS && _this.mode === 'development') {
                  imagePath = '/images/tempLogo.png';
                } else {
                  imagePath = imageSource || "https://cms-v2.yourhere.ca/containers/".concat(cms[_this.logoKey]);
                }

                return _this.createImageLabel({
                  mesh: assetMesh,
                  image: imagePath,
                  orientation: orientation,
                  scale: scale
                });
              });
              _context5.next = 5;
              return Promise.all(imagePromises);

            case 5:
              // console.timeEnd('create image labels')
              _this.timeEnd('create image labels');

            case 6:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x4) {
      return _ref19.apply(this, arguments);
    };
  }();

  this.hideAllLabels = function (id) {
    _this.log('Hide all text labels', id);

    _this.log(_this.scene.markerMeshes);

    _this.scene.markerMeshes.filter(function (m) {
      return !id || m.name === id + '-text';
    }).forEach(function (m) {
      return m.dispose();
    });

    _this.scene.markerMeshes = _this.scene.markerMeshes.filter(function (m) {
      return id && m.name !== id + '-text';
    });
  };

  this.highlightAmenities = function () {
    _this.log('Highlighting amenities', _this.activeAmenities);

    _this.timeStart('Highlight amenities');

    _this.hideAllFloorLabels();

    _this.scene.assets.forEach(function (a) {
      var _a$assetType = a.assetType,
          assetType = _a$assetType === void 0 ? [] : _a$assetType,
          _a$customType = a.customType,
          customType = _a$customType === void 0 ? '' : _a$customType,
          assetId = a.assetId;

      var matchingType = _this.activeAmenities.find(function (t) {
        return assetType.includes(t) || customType === t;
      });

      var isOnFloor = _this.activeFloors.includes((0, _getFloorFromName["default"])(a.assetId));

      if (matchingType) {
        _this.log("Highlighting ".concat(assetId));

        var mesh = _this.scene.getMeshByName(assetId);

        if (!mesh) {
          return;
        } // If we moved away from that floor, remove highlight


        if (!isOnFloor) {
          _this.handleFlyout(assetId, false);

          _this.markerToRenderLoop = _this.markerToRenderLoop.filter(function (m) {
            return m !== mesh;
          });
          return;
        }

        _this.pathfinding.pathRenderer.flatFlyout({
          id: assetId,
          position: mesh.position,
          image: _this.icons[matchingType],
          type: 'amenityLabel',
          mesh: mesh
        });
      }
    });

    _this.scene.allNodes.forEach(function (n) {
      var _n$assetType = n.assetType,
          assetType = _n$assetType === void 0 ? [] : _n$assetType,
          nodeId = n.nodeId;

      var matchingType = _this.activeAmenities.find(function (t) {
        return assetType.includes(t);
      });

      var isOnFloor = _this.activeFloors.includes(n.floor);

      if (matchingType) {
        var node = _this.scene.getMeshByName(nodeId) || _this.scene.getNodeByName(nodeId);

        if (!node) {
          return;
        } // If we moved away from that floor, remove highlight


        if (!isOnFloor) {
          _this.handleFlyout(nodeId, false);

          _this.markerToRenderLoop = _this.markerToRenderLoop.filter(function (m) {
            return m !== node;
          });
          return;
        }

        _this.pathfinding.pathRenderer.flatFlyout({
          id: nodeId,
          position: node.position,
          image: _this.icons[matchingType],
          type: 'amenityLabel',
          mesh: node
        });
      }
    });

    _this.timeEnd('Highlight amenities');
  };

  this.getNameFromCMS = function (id, tenantData) {
    var cmsAsset = _this.scene.assets.find(function (asset) {
      return id && "".concat(asset.cmsID) === "".concat(id);
    });

    if (cmsAsset) {
      return cmsAsset.assetId;
    }

    var tenant = tenantData.find(function (tenant) {
      return "".concat(tenant.suitenum) === "".concat(id);
    });

    if (tenant) {
      var tenantObject = {
        assetId: tenant.name,
        displayName: tenant.name,
        transferFloors: [],
        isUncharted: true,
        unchartedFloor: tenant.floornums
      };

      _this.scene.assets.push(tenantObject);

      _this.log('Get name from CMS', {
        id: id,
        tenantData: tenantData,
        tenantObject: tenantObject
      });

      return tenantObject.assetId;
    }

    _this.log('Get name from CMS - failed', {
      id: id,
      tenantData: tenantData
    });

    return null;
  };

  var _nodeSize = sceneOptions.nodeSize,
      _nodeColor = sceneOptions.nodeColor,
      _sceneOptions$mode = sceneOptions.mode,
      _mode = _sceneOptions$mode === void 0 ? 'development' : _sceneOptions$mode,
      _sceneOptions$debug = sceneOptions.debug,
      debug = _sceneOptions$debug === void 0 ? 0 : _sceneOptions$debug,
      primaryHighlight = sceneOptions.primaryHighlight,
      _sceneOptions$backgro = sceneOptions.backgroundColor,
      backgroundColor = _sceneOptions$backgro === void 0 ? '#CCCCCC' : _sceneOptions$backgro,
      _sceneOptions$icons = sceneOptions.icons,
      icons = _sceneOptions$icons === void 0 ? {} : _sceneOptions$icons,
      _sceneOptions$cameraB = sceneOptions.cameraBeta,
      cameraBeta = _sceneOptions$cameraB === void 0 ? 0 : _sceneOptions$cameraB,
      _sceneOptions$disable = sceneOptions.disableRotationX,
      _disableRotationX = _sceneOptions$disable === void 0 ? false : _sceneOptions$disable,
      _sceneOptions$disable2 = sceneOptions.disableRotationY,
      _disableRotationY = _sceneOptions$disable2 === void 0 ? false : _sceneOptions$disable2,
      _sceneOptions$maxRota = sceneOptions.maxRotation,
      maxRotation = _sceneOptions$maxRota === void 0 ? Infinity : _sceneOptions$maxRota,
      _sceneOptions$minRota = sceneOptions.minRotation,
      minRotation = _sceneOptions$minRota === void 0 ? -Infinity : _sceneOptions$minRota,
      _sceneOptions$disable3 = sceneOptions.disablePanning,
      _disablePanning = _sceneOptions$disable3 === void 0 ? false : _sceneOptions$disable3,
      _sceneOptions$logoKey = sceneOptions.logoKey,
      logoKey = _sceneOptions$logoKey === void 0 ? 'fileid' : _sceneOptions$logoKey,
      _sceneOptions$labelKe = sceneOptions.labelKey,
      labelKey = _sceneOptions$labelKe === void 0 ? 'name' : _sceneOptions$labelKe,
      _sceneOptions$labelFo = sceneOptions.labelFont,
      labelFont = _sceneOptions$labelFo === void 0 ? 'Arial' : _sceneOptions$labelFo,
      _sceneOptions$maxText = sceneOptions.maxTextLabelSize,
      maxTextLabelSize = _sceneOptions$maxText === void 0 ? 0.005 : _sceneOptions$maxText,
      _sceneOptions$floorLa = sceneOptions.floorLabelOffsetMult,
      floorLabelOffsetMult = _sceneOptions$floorLa === void 0 ? 1.1 : _sceneOptions$floorLa,
      _sceneOptions$floorLa2 = sceneOptions.floorLabels,
      floorLabels = _sceneOptions$floorLa2 === void 0 ? {} : _sceneOptions$floorLa2,
      _sceneOptions$activeA = sceneOptions.activeAmenities,
      activeAmenities = _sceneOptions$activeA === void 0 ? [] : _sceneOptions$activeA,
      _sceneOptions$hideFlo = sceneOptions.hideFloorLabels,
      hideFloorLabels = _sceneOptions$hideFlo === void 0 ? false : _sceneOptions$hideFlo;

  var handleFlyout = functions.handleFlyout,
      setRotation = functions.setRotation;
  var meshList = [];
  var markerToRenderLoop = [];
  this.icons = icons;
  this.labelFont = labelFont;
  this.floorLabels = floorLabels;
  this.hideFloorLabels = hideFloorLabels;
  this.nodeSize = _nodeSize;
  this.nodeColor = _nodeColor;
  this.meshList = meshList;
  this.markerToRenderLoop = markerToRenderLoop;
  this.mode = _mode;
  this.activeAmenities = activeAmenities.filter(function (type) {
    if (!icons.hasOwnProperty(type)) {
      console.warn('Missing icon for type', type);
      return false;
    }

    return true;
  });
  this.isMoving = false;
  this.showingRoomLabels = false;
  this.scene = _scene;
  this.handleFlyout = handleFlyout;

  this.setRotation = function (yVal) {
    setRotation({
      y: yVal
    });
  }; // Level 0 = no logs
  // Level 1 = timers
  // Level 2 = timers + logs


  this.debug = debug;
  this.reservedWords = ['room', 'elevator', 'stair', 'escalator', 'ramp', 'anchor', 'marker'];
  this.primaryHighlight = primaryHighlight;
  this.highlights = [];
  this.tempHighlights = [];
  this.cachedRotationValues = {};
  this.floorLabelOffset = 0;
  this.floorLabelOffsetMult = floorLabelOffsetMult;
  this.floorSpace = 1;
  this.lastNode = null;
  this.logoKey = logoKey;
  this.labelKey = labelKey;
  this.maxTextLabelSize = maxTextLabelSize;
  this.disableRotationY = _disableRotationY;
  this.disablePanning = _disablePanning;
  _scene.assets = [];
  _scene.linkMeshes = [];
  _scene.markerMeshes = [];
  _scene.floors = [];

  _scene.meshes.forEach(function (mesh) {
    var meshFloor = (0, _getFloorFromName["default"])(mesh.name);

    if (!meshFloor) {
      _this.log('Failed to find floor for mesh', mesh);
    }

    var copyMeshName = mesh.name.toLowerCase(); // Make each mesh a child of the floor it belongs to

    var floorMesh = _scene.getMeshByName(meshFloor);

    if (floorMesh) {
      floorMesh.addChild(mesh);
    } else {
      console.warn('Failed to get floor mesh for mesh:', mesh.name);
      return;
    }

    if (_this.reservedWords.some(function (word) {
      return copyMeshName.includes(word);
    })) {
      _scene.assets.push({
        assetId: mesh.name,
        position: mesh.absolutePosition,
        transferFloors: [],
        uncharted: ''
      });
    }

    if (meshFloor && !_scene.floors.find(function (f) {
      return f.name === meshFloor;
    })) {
      var _floorMesh$getBoundin = floorMesh.getBoundingInfo(),
          _floorMesh$getBoundin2 = _floorMesh$getBoundin.boundingBox.extendSizeWorld,
          x = _floorMesh$getBoundin2.x,
          z = _floorMesh$getBoundin2.z;

      _this.floorLabelOffset = Math.max(_this.floorLabelOffset, Math.sqrt(Math.pow(x, 2) + Math.pow(z, 2)));

      _scene.floors.push({
        name: meshFloor,
        order: _scene.floors.length
      });
    }
  });

  this.activeFloors = _toConsumableArray(_scene.floors);
  _scene.clearColor = this.mode === 'production' ? BABYLON.Color3.FromHexString(backgroundColor) : new BABYLON.Color3(0.1, 0.1, 0.1);
  _scene.allNodes = [];
  _scene.allShops = [];
  _scene.pivots = [];
  _scene.links = [];
  _scene.nodeCount = 0;
  _scene.logoMeshes = [];
  var gizmoManager = new BABYLON.GizmoManager(_scene);
  gizmoManager.positionGizmoEnabled = true;
  gizmoManager.gizmos.positionGizmo.xGizmo.dragBehavior.onDragObservable.add(function () {
    var name = gizmoManager.gizmos.positionGizmo.attachedMesh.name;

    _this.hideLinks({
      name: name
    });

    _this.showLinks({
      name: name
    });
  });
  gizmoManager.gizmos.positionGizmo.zGizmo.dragBehavior.onDragObservable.add(function () {
    var name = gizmoManager.gizmos.positionGizmo.attachedMesh.name;

    _this.hideLinks({
      name: name
    });

    _this.showLinks({
      name: name
    });
  });
  gizmoManager.usePointerToAttachGizmos = false;
  var _positionGizmo = gizmoManager.gizmos.positionGizmo;
  _positionGizmo.scaleRatio = 0.1;
  _positionGizmo.yGizmo.isEnabled = false;
  _scene.dragHandler = gizmoManager;
  this.pathfinding = new _pathfinding["default"](this, meshList, markerToRenderLoop);
  this.orthoScale = 0.01;
  var _this$scene3 = this.scene,
      _camera = _this$scene3.camera,
      canvas = _this$scene3.canvas,
      _options = _this$scene3.options; // limit camera rotation

  _camera.lowerBetaLimit = 0.02;
  _camera.upperBetaLimit = Math.PI * 0.45;
  _camera.lowerAlphaLimit = 0;
  _camera.upperAlphaLimit = 0;
  _camera.beta = cameraBeta; // if (disableRotationX) {
  //   camera.lowerBetaLimit = Math.PI * 0.3
  //   camera.upperBetaLimit = Math.PI * 0.3
  // }
  // const maxRotation = 0.5 * Math.PI
  // const minRotation = -0.5 * Math.PI

  _camera.znear = 10000;
  this.orthoScale = _options.orthoScale || 0.01;
  this.setOrthoCamera(this.orthoScale);
  _camera.radius = 500;
  var pointerState = [];
  var prevDiff = -1;

  var pointerDown = function pointerDown(e) {
    pointerState.push(e);
  };

  var pointerMove = function pointerMove(e) {
    var foundCachedEvent = pointerState.findIndex(function (cachedEvent) {
      return e.pointerId === cachedEvent.pointerId;
    });

    if (foundCachedEvent !== -1) {
      pointerState[foundCachedEvent] = e;
    }

    var currDiff;

    if (pointerState.length === 2) {
      currDiff = Math.abs(pointerState[0].clientX - pointerState[1].clientX);

      if (prevDiff > 0) {
        if (currDiff > prevDiff) {
          // Zoom in
          _this.cameraMove('in', 1);
        }

        if (currDiff < prevDiff) {
          // Zoom out
          _this.cameraMove('out', 1);
        }
      }

      prevDiff = currDiff;
    }
  };

  var pointerEnd = function pointerEnd(e) {
    pointerState = pointerState.filter(function (cachedEvent) {
      return cachedEvent.pointerId !== e.pointerId;
    });

    if (pointerState.length < 2) {
      prevDiff = -1;
    }
  }; // attach pointer events


  canvas.onpointerdown = pointerDown;
  canvas.onpointermove = pointerMove;
  canvas.onpointerup = pointerEnd;
  canvas.onpointercancel = pointerEnd;
  canvas.onpointerout = pointerEnd;
  canvas.onpointerleave = pointerEnd;

  canvas.onwheel = function (e) {
    e.preventDefault();
    var deltaY = e.deltaY;

    if (deltaY < 0) {
      // Zoom in
      _this.cameraMove('in', 1);
    } else {
      // Zoom out
      _this.cameraMove('out', 1);
    }
  };

  _camera.inputs.remove(_camera.inputs.attached.mousewheel); // Move meshes on mouse move


  var dragInit;
  var dragDiff;
  var rotating;
  var prevX;
  var prevDirection;

  var onPointerDown = function onPointerDown(e) {
    if (_this.disableRotationY) {
      return;
    }

    if (e.button !== 2) {
      return;
    }

    rotating = true;
    var evt = e ? e : window.event;
    dragInit = {
      x: evt.x,
      y: evt.y
    };
  };

  var onPointerUp = function onPointerUp() {
    if (_this.disableRotationY) {
      return;
    }

    rotating = false;
    prevX = null;
    prevDirection = null; // this.refreshConfigAfterMove()

    var recentRotation = _this.cachedRotationValues && Object.values(_this.cachedRotationValues)[0];

    if (typeof recentRotation === 'number') {
      _this.setRotation(recentRotation);
    }
  };

  var rotationDebounce = false;

  var onPointerMove = function onPointerMove(evt) {
    if (_this.disableRotationY) {
      return;
    }

    if (!rotating || _this.isMoving) {
      return;
    }

    if (!prevX) {
      prevX = evt.x;
    } else {
      var diff = evt.x - prevX;
      var currentDirection = prevDirection;
      currentDirection = diff < 0 ? 'Left' : 'Right';

      if (prevDirection && currentDirection !== prevDirection) {
        prevX = null;
        prevDirection = null;
        dragInit = {
          x: evt.x,
          y: evt.y
        };
      }

      prevX = evt.x;
      prevDirection = currentDirection;
    }

    dragDiff = {
      x: evt.x - dragInit.x,
      y: evt.y - dragInit.y
    };

    _scene.floors.forEach(function (_ref20) {
      var name = _ref20.name;

      var m = _scene.getMeshByName(name);

      if (!m) {
        return;
      }

      var newRotation = m.rotation.y - dragDiff.x / 1000;

      if (newRotation < minRotation) {
        newRotation = minRotation;
      }

      if (newRotation > maxRotation) {
        newRotation = maxRotation;
      }

      var normalRotation = newRotation % (Math.PI * 2);

      if (!rotationDebounce) {
        _this.setRotation(normalRotation);

        rotationDebounce = true;
        setTimeout(function () {
          rotationDebounce = false;
        }, 100);
      }

      m.rotation.y = normalRotation;
      _this.cachedRotationValues[name] = normalRotation;
    });

    return true;
  };

  canvas.addEventListener("pointerdown", onPointerDown, false);
  canvas.addEventListener("pointerup", onPointerUp, false);
  canvas.addEventListener("pointermove", onPointerMove, false);
  _scene.activeCamera = _camera;

  _camera.attachControl(canvas, true, false, 0);

  var _pointers = _camera.inputs.attached.pointers; // camera.panningDistanceLimit = 20

  _pointers.pinchPrecision = 30;
  _pointers.angularSensibilityX = 2500;
  _pointers.angularSensibilityY = _disableRotationX ? Infinity : 2500;
  _pointers.panningSensibility = 75;

  if (_disablePanning) {
    _pointers.panningSensibility = 0;
  }

  this.setActiveFloor([], false);
};

exports["default"] = SceneWrapper;

SceneWrapper.createBabylonScene = function (_ref21) {
  var engine = _ref21.engine,
      canvas = _ref21.canvas,
      fileData = _ref21.fileData,
      _ref21$useFilePath = _ref21.useFilePath,
      useFilePath = _ref21$useFilePath === void 0 ? false : _ref21$useFilePath,
      _ref21$options = _ref21.options,
      options = _ref21$options === void 0 ? {} : _ref21$options;
  return new Promise(function (resolve) {
    // Create the scene space
    var scene = new BABYLON.Scene(engine);
    scene.sceneEngine = engine;
    var camera = new BABYLON.ArcRotateCamera('3dMapCam', BABYLON.Tools.ToRadians(0), BABYLON.Tools.ToRadians(0), 10.0, BABYLON.Vector3.Zero(), scene);
    camera.mode = BABYLON.Camera.ORTHOGRAPHIC_CAMERA;
    scene.camera = camera;
    scene.options = options;
    scene.canvas = canvas; // Light direction is up and left

    var ambientLight = new BABYLON.HemisphericLight('hemiLight', new BABYLON.Vector3(0, 1, 0), scene);
    ambientLight.diffuse = new BABYLON.Color3(1, 1, 1);
    ambientLight.intensity = 1;
    var ambientLightBottom = new BABYLON.HemisphericLight('hemiLight', new BABYLON.Vector3(0, -1, 0), scene);
    ambientLightBottom.diffuse = new BABYLON.Color3(1, 1, 1);
    ambientLightBottom.intensity = 0.5;
    BABYLON.SceneLoader.ShowLoadingScreen = false;
    scene.ambientColor = new BABYLON.Color3(0.01, 0.01, 0.99);
    scene.clearColor = new BABYLON.Color3(0.01, 0.01, 0.99);
    var rootUrl = useFilePath ? fileData : '';
    var fileName = useFilePath ? '' : "data:".concat(fileData); // Render a double size image of the scene, then apply antialiasing over the image. 

    new BABYLON.PassPostProcess('pass_2', 2.0, camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE);
    new BABYLON.FxaaPostProcess('fxaa', 1.0, camera);
    new BABYLON.PassPostProcess('pass_1', 1.0, camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE);
    BABYLON.SceneLoader.AppendAsync(rootUrl, fileName, scene).then(function (loadedScene) {
      resolve(loadedScene);
    })["catch"](function (err) {
      console.error(err);
    });
  });
};

SceneWrapper.disableHighlight = function (mesh) {
  if (mesh.oldMaterial) {
    mesh.material = mesh.oldMaterial;
    mesh.isPickable = true;
    delete mesh.oldMaterial;
  }
};

SceneWrapper.getLongSide = function (path) {
  var splitPath = path.reduce(function (paths, point) {
    var pointFloor = point.floor || (0, _getFloorFromName["default"])(point.nodeId);

    if (!paths[pointFloor]) {
      paths[pointFloor] = [];
    }

    paths[pointFloor].push({
      position: point.position,
      name: point.nodeId
    });
    return paths;
  }, {});
  return Object.entries(splitPath).map(function (_ref22) {
    var _ref23 = _slicedToArray(_ref22, 2),
        floor = _ref23[0],
        points = _ref23[1];

    var distances = [];
    points.forEach(function (pointA, i) {
      points.slice(i + 1).forEach(function (pointB) {
        distances.push({
          pointA: pointA,
          pointB: pointB,
          distance: Math.sqrt(_pathfinding["default"].distanceBetweenCoords(pointA.position, pointB.position))
        });
      });
    });
    distances.sort(function (a, b) {
      return a.distance - b.distance;
    });
    return {
      floor: floor,
      side: distances.pop()
    };
  });
};

SceneWrapper.roundPosition = function (position, scale, rotation, floorPosition) {
  // Get the current position of the mouse relative to the floor
  var _position$subtract = position.subtract(floorPosition),
      x = _position$subtract.x,
      z = _position$subtract.z; // Rotate the position to the same angle as the floor
  // so the point on the floor is the same regardless of rotation


  var floorX = x * Math.cos(-rotation) + z * Math.sin(-rotation);
  var floorZ = z * Math.cos(-rotation) - x * Math.sin(-rotation); // Round the position to a spot on an imaginary "grid" on the floor

  var gridX = Math.round(floorX / scale) * scale;
  var gridZ = Math.round(floorZ / scale) * scale; // Reverse the rotation

  var roundedFloorX = gridX * Math.cos(rotation) + gridZ * Math.sin(rotation);
  var roundedFloorZ = gridZ * Math.cos(rotation) - gridX * Math.sin(rotation); // Add the floor's position to the new, rounded, unrotated position

  var roundedActualX = roundedFloorX + floorPosition.x;
  var roundedActualZ = roundedFloorZ + floorPosition.z;
  return {
    x: roundedActualX,
    y: floorPosition.y,
    z: roundedActualZ
  };
};